<script>
import VueCharts from 'vue-chartjs'
import { Doughnut } from 'vue-chartjs'

export default {
    extends: Doughnut,
    props: ['chartdata', 'options', 'height'],
    mounted () {
        let _data = JSON.parse(this.chartdata)

        let _chartData = {
            datasets: [{
                backgroundColor: [
                '#2AB27B',
                '#E03D21'
                ],
                data: [this.toNumber(_data.income), this.toNumber(_data.expense)]
            }],
            labels: [
                'Einnahmen',
                'Ausgaben'
            ],

        }

        this.renderChart(_chartData, {
            rotation: 1 * Math.PI,
            circumference: 1 * Math.PI,
            responsive: true,
            maintainAspectRatio: false
        })
    },
    watch: {
        chartdata: function(newval, oldval) {

            let _data = newval

            let _chartData = {
                datasets: [{
                    backgroundColor: [
                    '#2AB27B',
                    '#E03D21'
                    ],
                    data: [this.toNumber(_data.income), this.toNumber(_data.expense)]
                }],
                labels: [
                    'Einnahmen',
                    'Ausgaben'
                ],

            }

            this.renderChart(_chartData, {
                rotation: 1 * Math.PI,
                circumference: 1 * Math.PI,
                responsive: true,
                maintainAspectRatio: false
            })
        }
    },
    methods: {
        toNumber: function (number) {

            let _formatted = number.toString()

            if (_formatted.indexOf(',')) _formatted.replace(/\./g, '').replace(/,/g,'.')

            return parseFloat(_formatted);
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/ckSaldoChart.vue